
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.836 9.125a.79.79 0 010 1.152.818.818 0 01-1.152 0 4.06 4.06 0 010-5.737l2.873-2.872a4.06 4.06 0 015.737 0 4.06 4.06 0 010 5.737l-1.21 1.209a5.606 5.606 0 00-.324-1.964l.381-.39a2.42 2.42 0 000-3.44 2.42 2.42 0 00-3.44 0L6.836 5.685a2.42 2.42 0 000 3.44zm2.289-3.44a.818.818 0 011.152 0 4.06 4.06 0 010 5.737l-2.873 2.872a4.06 4.06 0 01-5.737 0 4.06 4.06 0 010-5.737l1.21-1.209c-.009.665.097 1.33.324 1.972L2.82 9.7a2.42 2.42 0 000 3.44 2.42 2.42 0 003.44 0l2.865-2.864a2.42 2.42 0 000-3.44.79.79 0 010-1.152z","fill":"#6D6D6D"}})])
          )
        }
      }
    